<template>
  <div class="app-container">
    <el-row :gutter="20">
      <el-col :span="24" :xs="24">
        <el-form :model="queryParams" ref="queryParams" size="small" v-show="showSearch" label-width="80px">
          <el-row :gutter="24" type="flex" justify="right">
            <el-col :span="5">
              <el-form-item label="识别码" prop="OIDNO">
                <el-input v-model="queryParams.OIDNO" placeholder="请输入识别码" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="使用单位" prop="USE_UNT_NAME">
                <el-input v-model="queryParams.USE_UNT_NAME" placeholder="请输入使用单位" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="单位地址" prop="EQP_USE_ADDR">
                <el-input v-model="queryParams.EQP_USE_ADDR" placeholder="请输入使用单位地址" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="产品编号" prop="FACTORY_COD">
                <el-input v-model="queryParams.FACTORY_COD" placeholder="请输入产品编号" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="内部编号" prop="EQP_INNER_COD">
                <el-input v-model="queryParams.EQP_INNER_COD" placeholder="请输入内部编号" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="状态" prop="status">
                <el-select v-model="queryParams.status" placeholder="请选择状态" style="width: 100%;" @change="handleQuery">
                  <el-option label="全部" value="-1"></el-option>
                  <el-option label="暂存" value="0"></el-option>
                  <!-- <el-option label="已录入" value="1"></el-option> -->
                  <el-option label="退回" value="2,4"></el-option>
                  <el-option label="未录入" value="9"></el-option>
                  <!-- <el-option label="待提交/整改项退回" value="4"></el-option> -->
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row :gutter="24" type="flex" justify="right"></el-row> -->
          <div style="text-align: center;margin-bottom: 10px;">
            <PermissionMethodToolbar :url="url" :id="'toolbar'" :disabledButtons="toolbarDisabledButtons" @handleQuery="handleQuery" @exportToExcel="exportToExcel" @handleDelete="handleDelete" />
          </div>
          <div class="table-loading-wrap" v-loading="loading" element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading">
            <el-table id="table" :data="tableData" border style="width: 100%; margin-top: 20px" :header-cell-style="{ background: '#d8e8fb', textAlign: 'left', borderColor: '#CCC' }"
                      row-key="_uniqueKey" ref="originalManagementTable" height="500" :key="tableKey" @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="55" fixed="left"></el-table-column>
              <el-table-column type="index" label="序号" width="50" align="center" fixed="left"></el-table-column>
              <el-table-column label="状态" align="left" prop="status" min-width="100" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-tag :type="getStatusType(scope.row.status + '')">
                    {{ getStatusText(scope.row.status + '') }}
                  </el-tag>
                </template>
              </el-table-column>
              <!-- <el-table-column label="认领日期" align="left" prop="claimDate" width="120" show-overflow-tooltip :formatter="$tableDateFormatter"></el-table-column> -->
              <el-table-column label="使用单位名称" align="left" prop="USE_UNT_NAME" min-width="160" show-overflow-tooltip></el-table-column>
              <el-table-column label="电梯识别码" align="left" prop="OIDNO" width="100" show-overflow-tooltip ></el-table-column>
              <el-table-column label="产品编号" align="left" prop="FACTORY_COD" min-width="100" show-overflow-tooltip></el-table-column>
              <el-table-column label="内部编号" align="left" prop="eqpInnerCod" min-width="120" show-overflow-tooltip></el-table-column>
              <el-table-column label="层数/高度/长度" align="left" prop="ELEFLOORNUMBER" min-width="120" show-overflow-tooltip></el-table-column>
              <el-table-column label="设备名称" align="left" prop="eqpTempName" min-width="120" show-overflow-tooltip></el-table-column>
              <el-table-column label="小区名称" align="left" prop="houseName" min-width="150" show-overflow-tooltip></el-table-column>
              <el-table-column label="使用单位地址" align="left" prop="EQP_USE_ADDR" min-width="200" show-overflow-tooltip></el-table-column>
              <!-- <el-table-column label="产品名称" align="left" prop="productName" min-width="160" show-overflow-tooltip></el-table-column> -->
              <el-table-column label="设备信息状态" align="left" prop="equipmentConfirmed" min-width="120" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-tag :type="getEquipmentConfirmedType(scope.row.equipmentConfirmed)">
                    {{ getEquipmentConfirmedText(scope.row.equipmentConfirmed) }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column label="退回原因" align="left" prop="backReason" min-width="200" show-overflow-tooltip></el-table-column>
              <el-table-column label="委托编号" align="left" prop="entrustNum" width="180" show-overflow-tooltip ></el-table-column>
              <el-table-column label="操作" align="left" width="400" fixed="right">
                <template slot-scope="scope">
                  <!-- <el-button type="text" size="small" @click="handleRecord(scope.row)" v-if="scope.row.status === '0'">录入原始记录</el-button> -->
                  <PermissionMethodRow :url="url" :id="'rowtoolbar'" :disabledButtons="getDisabledButtons(scope.row)" @handleequipment="handleEquipment(scope.row)"
                                       @handleRecord="handleRecord(scope.row)" @handlePDF="handlePDF(scope.row)" @Deletedeviceinformation="Deletedeviceinformation(scope.row)" />
                </template>
              </el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryParams.currPage" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="queryParams.pageSize"
                           layout="total, sizes, prev, pager, next, jumper" :total="total" style="margin-top: 20px; text-align: right;">
            </el-pagination>
          </div>
        </el-form>
      </el-col>
    </el-row>

    <!-- 引入新增/修改弹窗组件 -->
    <AddAndEdit ref="addEdit" @refresh="getList" />

    <!-- 设备确认弹窗 -->
    <EquipmentConfirmDialog ref="equipmentConfirmDialog" @confirmed="getList" />

    <!-- PDF预览弹窗 -->
    <el-dialog title="PDF预览" :visible.sync="pdfPreviewVisible" width="90%" :close-on-click-modal="false">
      <PdfImgViewer v-if="pdfPreviewVisible && pdfFileName" :fileName="pdfFileName" />
      <div slot="footer" class="dialog-footer">
        <el-button @click="pdfPreviewVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import AddAndEdit from './AddAndEdit.vue';
import PdfImgViewer from '@/components/pdfview/PdfImgViewer.vue';
import EquipmentConfirmDialog from './EquipmentConfirmDialog.vue';
import { queryTestDataList, queryTestDataInfo, saveTestData, previewTestDataPdf, queryTestData, deleteOriginalRecord, deleteMemoAndBackToTest } from '@/api/contract/contract';

export default {
  name: 'OriginalManagement',
  components: {
    AddAndEdit,
    PdfImgViewer,
    EquipmentConfirmDialog
  },
  props: {
    url: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      optPerm: {},
      // 显示搜索条件
      showSearch: true,
      tableData: [],
      // 遮罩层
      loading: true,
      // 总条数
      total: 0,
      // 查询参数
      queryParams: {
        currPage: 1,
        pageSize: 200,
        OIDNO: undefined,
        useUnit: undefined,
        EQP_USE_ADDR: undefined,
        FACTORY_COD: undefined,
        EQP_INNER_COD: undefined,
        status: '-1'
      },
      // PDF预览相关
      pdfPreviewVisible: false, // PDF预览弹窗显示状态
      pdfFileName: '', // PDF文件名
      tableKey: 0, // 表格key，用于强制刷新
      backReasonstatus: false,
      selectedEntrustNums: []
    };
  },
  computed: {
    toolbarDisabledButtons () {
      return this.selectedEntrustNums.length > 0 ? [] : ['handleDelete']
    }
  },
  created () {
    this.getList();
    // 监听刷新标记
    this.checkRefreshFlag();
  },
  mounted () {
    // 添加窗口焦点事件监听，当标签页重新激活时检查是否需要刷新
    window.addEventListener('focus', this.checkRefreshFlag);
  },
  beforeDestroy () {
    // 移除事件监听
    window.removeEventListener('focus', this.checkRefreshFlag);
  },
  methods: {
    isEquipmentConfirmed (val) {
      if (val === true) return true
      if (val === false) return false
      if (val === 1 || val === '1') return true
      if (val === 0 || val === '0') return false
      if (val === 'true') return true
      if (val === 'false') return false
      return false
    },
    getEquipmentConfirmedType (val) {
      return this.isEquipmentConfirmed(val) ? 'success' : 'info'
    },
    getEquipmentConfirmedText (val) {
      return this.isEquipmentConfirmed(val) ? '已确认' : '未确认'
    },
    // 检查是否需要刷新列表
    checkRefreshFlag () {
      const refreshKey = 'needRefreshOriginalManagement';
      const refreshFlag = sessionStorage.getItem(refreshKey);
      if (refreshFlag) {
        // 清除标记
        sessionStorage.removeItem(refreshKey);
        // 刷新列表
        console.log('检测到刷新标记，正在刷新列表...');
        this.getList();
      }
    },
    // 获取状态标签类型
    getStatusType (status) {
      switch (status) {
        case '0':
          return 'warning';
        case '1':
          return 'success';
        case '2':
          return 'danger';
        case '9':
          return 'info';
        case '4':
          return 'danger';
        default:
          return 'info';
      }
    },
    // 获取状态文本
    getStatusText (status) {
      switch (status) {
        case '0':
          return '暂存';
        case '1':
          return '已录入';
        case '2':
          return '退回';
        case '9':
          return '未录入';
        case '4':
          // return '待提交/整改项退回';
          return '退回';
        default:
          return '未知';
      }
    },
    // 搜索
    handleQuery () {
      this.queryParams.currPage = 1;
      this.tableKey++; // 强制刷新表格
      this.getList();
    },
    // 分页大小改变
    handleSizeChange (val) {
      this.queryParams.pageSize = val;
      this.queryParams.currPage = 1;
      this.getList();
    },
    // 当前页改变
    handleCurrentChange (val) {
      this.queryParams.currPage = val;
      this.getList();
    },
    // 表格勾选变化
    handleSelectionChange (selection) {
      this.selectedEntrustNums = selection.map(item => item.entrustNum).filter(Boolean)
    },
    // 查询列表
    getList () {
      this.loading = true;
      if (this.queryParams.status === '2') {
        this.backReasonstatus = true;
      } else {
        this.backReasonstatus = false;
      }
      // 调用queryTestDataList API
      queryTestDataList(this.queryParams).then(res => {
        if (res.retCode === 'ok') {
          this.tableData = res.additionalData.records;
          this.selectedEntrustNums = [];
          this.queryParams.currPage = res.additionalData.current;
          this.queryParams.pageSize = res.additionalData.size;
          this.total = res.additionalData.total;
          // this.tableData.push({ eqpTempName: '自动扶梯原始记录' })
          // this.tableData.push({ eqpTempName: '曳引驱动有机房乘客电梯' })
        }
        this.loading = false;
      }).catch(error => {
        console.error('获取数据失败:', error);
        this.loading = false;
        this.$message.error('获取数据失败');
      });
    },
    // 新增按钮
    handleAdd () {
      this.$refs.addEdit.openDialog('Add');
    },
    // 修改按钮
    handleEdit (row) {
      this.$refs.addEdit.openDialog('Edit', row);
    },

    // 确认设备信息（打开弹窗）
    handleEquipment (row) {
      if (!row) return
      if (!row.entrustNum) {
        this.$message.warning('缺少委托编号')
        return
      }
      this.$refs.equipmentConfirmDialog && this.$refs.equipmentConfirmDialog.show(row)
    },

    // 录入原始记录按钮
    handleRecord (row) {
      if (!this.isEquipmentConfirmed(row.equipmentConfirmed)) {
        this.$message.warning('设备信息未确认，无法录入原始记录')
        return
      }
      // 将数据存储到sessionStorage中，避免URL参数过长的问题
      const recordData = {
        entrustNum: row.entrustNum || '',
        useUnitName: row.USE_UNT_NAME || '',
        elevatorCode: row.OIDNO || '',
        productNumber: row.FACTORY_COD || '',
        equipmentName: row.matchRecord || '',
        configReportPid: row.configReportPid,
        status: row.status,
        FIRST_YEAR: row.FIRST_YEAR,
        timestamp: Date.now()
      };

      // 生成唯一的数据键
      const dataKey = `recordData_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
      sessionStorage.setItem(dataKey, JSON.stringify(recordData));
      console.log('存储到sessionStorage的dataKey:', dataKey);
      console.log('存储的数据:', recordData);
      console.log('验证存储:', sessionStorage.getItem(dataKey));

      // 使用框架的标签页方式打开原始记录页面，只传递数据键
      // const targetUrl = `views/business/OriginalManagement/RecordDialog.vue?dataKey=${dataKey}`;
      let targetUrl = ''
      if (recordData.equipmentName === '曳引式客梯' || recordData.equipmentName === '曳引式货梯') {
        targetUrl = `views/business/OriginalManagement/RecordDialog.vue?dataKey=${dataKey}`;
      } else if (recordData.equipmentName === '自动扶梯原始记录' || recordData.equipmentName === '自动人行道原始记录') {
        targetUrl = `views/business/OriginalManagement/RecordDialog2.vue?dataKey=${dataKey}`;
      } else if (recordData.equipmentName === '曳引驱动杂物电梯') {
        targetUrl = `views/business/OriginalManagement/RecordDialog3.vue?dataKey=${dataKey}`;
      } else if (recordData.equipmentName === '消防员电梯') {
        targetUrl = `views/business/OriginalManagement/RecordDialog4.vue?dataKey=${dataKey}`;
      }
      console.log('打开的URL:', targetUrl);

      // 查找并调用父组件的addTab方法
      let parent = this.$parent;
      while (parent && !parent.addTab) {
        parent = parent.$parent;
      }
      if (parent && parent.addTab) {
        parent.addTab('录入原始记录', targetUrl);
      } else {
        console.error('无法找到父组件的addTab方法');
        // 备选方案：直接打开新窗口
        const newWindow = window.open('about:blank', '_blank');
        if (newWindow) {
          newWindow.location.href = `/main#${targetUrl}`;
        }
      }
    },
    // 查看PDF按钮
    handlePDF (row) {
      console.log(row.status == '1');
      if (row.status != '9') {
        // 弹出选择框让用户选择打印类型
        this.$confirm('请选择要查看的内容：', '选择打印类型', {
          distinguishCancelAndClose: true,
          confirmButtonText: '原始记录',
          cancelButtonText: '报告',
          type: 'info'
        }).then(() => {
          // 用户选择了原始记录 (type: 1)
          this.callPreviewAPI(row.entrustNum, 1);
        }).catch(action => {
          if (action === 'cancel') {
            // 用户选择了报告 (type: 0)
            this.callPreviewAPI(row.entrustNum, 0);
          }
          // 如果是 close，则不执行任何操作
        });
      } else {
        this.$message.error('该原始记录未录入，无法查看PDF');
        return false;
      }
    },

    // 调用预览PDF的API
    callPreviewAPI (entrustNum, type) {
      // 显示全屏遮罩层
      const loading = this.$loading({
        lock: true,
        text: '正在生成PDF，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      previewTestDataPdf({ entrustNums: [entrustNum], type: type }).then(response => {
        console.log(response);
        loading.close();

        if (response && response.retCode === 'ok' && response.additionalData) {
          // 设置PDF文件名并打开预览弹窗
          this.pdfFileName = response.additionalData + '.pdf';
          this.pdfPreviewVisible = true;
          this.$message.success('PDF生成成功');
        } else {
          this.$message.error(response.retMsg || 'PDF生成失败');
        }
      }).catch(error => {
        console.error('查看PDF失败:', error);
        loading.close();
        this.$message.error('查看PDF失败');
      });
    },
    // 导出按钮
    exportToExcel () {
      this.$message.success('正在导出原始记录数据...');

      // 调用导出接口
      exportOriginalRecordExcel(this.queryParams).then(response => {
        // 创建下载链接
        const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);

        // 创建下载链接元素
        const link = document.createElement('a');
        link.href = url;
        link.download = '原始记录数据.xlsx'; // 文件名

        // 触发下载
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();

        // 清理
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        this.$message.success('导出成功');
      }).catch(error => {
        console.error('导出失败:', error);
        this.$message.error('导出失败：' + (error.message || '未知错误'));
      });
    },
    // 删除按钮
    handleDelete (row) {
      // const entrustNums = row && row.entrustNum ? [row.entrustNum] : this.selectedEntrustNums
      if (!this.selectedEntrustNums || this.selectedEntrustNums.length === 0) {
        this.$message.warning('请先勾选需要删除的原始记录');
        return
      }
      this.$confirm('确定删除该原始记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteOriginalRecord(this.selectedEntrustNums).then(res => {
          if (res.retCode === 'ok') {
            this.$message.success('删除成功');
            this.getList();
          }
        }).catch(error => {
          console.error('删除失败:', error);
          this.$message.error('删除失败');
        });
      });
    },
    Deletedeviceinformation (row) {
      if (!row || !row.entrustNum) {
        this.$message.warning('缺少委托编号，无法删除设备信息')
        return
      }
      this.$confirm('确定删除该设备信息吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteMemoAndBackToTest({ entrustNum: row.entrustNum }).then(res => {
          if (res.code === 200) {
            this.$message.success(res.message || '删除设备信息成功')
            this.getList()
            return
          }
          this.$message.error(res.retMsg || '删除设备信息失败')
        }).catch(error => {
          console.error('删除设备信息失败:', error)
          this.$message.error(error && error.message ? error.message : '删除设备信息失败')
        })
      })
    },
    /**
* 获取禁用的按钮列表
* @param {Object} row - 当前行数据
* @returns {Array} 禁用的按钮名称数组
*/
    getDisabledButtons (row) {
      if (!(row.status == '2' || row.status == '0')) {
        return ['handleDelete']
      }
      return []
    }

  }
};

</script>

<style scoped>
.loading-container {
  padding: 20px;
  text-align: center;
}
.no-data {
  padding: 20px;
  text-align: center;
  color: #909399;
}
::v-deep .el-table__body-wrapper {
  z-index: 2;
}
</style>
